import React from "react";
import { useLocation } from "react-router-dom";
import SEOHead from "./SEOHead";

// Az alias URL-ek SEO konfigurációja
// canonical: az eredeti, kanonikus oldal URL-je
//
// FIGYELEM: ezek az oldalak a canonicaljuk miatt NEM tudnak önállóan
// rangsorolni – a jelük a hub-oldalra konszolidálódik. Ezért NEM valók a
// sitemapba (lásd docs/seo-terv-markak.md). Ha egy útvonalra valódi keresési
// szándék van, ne aliast csinálj belőle, hanem önálló oldalt – ahogy az
// /iphone-szerviz-oroshaza, /samsung-szerviz-oroshaza és
// /iphone-felvasarlas-oroshaza esetében is történt.
const SEO_CONFIG = {
  // Szerviz alias-ok
  "/telefon-szerviz-oroshaza": {
    title: "Telefon szerviz Orosházán",
    description: "Gyors mobiltelefon javítás Orosházán. Kijelzőcsere, akkucsere és teljes szerviz garanciával.",
    canonical: "/szerviz",
  },
  "/kijelzocsere-oroshaza": {
    title: "Kijelzőcsere Orosházán akár másnapra",
    description: "Betört telefon kijelző csere Orosházán. iPhone, Samsung, Xiaomi, Honor és Huawei javítás garanciával.",
    canonical: "/szerviz",
  },
  "/akkucsere-oroshaza": {
    title: "Telefon akkucsere Orosházán",
    description: "Gyors akkumulátor csere Orosházán, garanciával. iPhone és Android akkucsere.",
    canonical: "/szerviz",
  },
  "/mobil-szerviz-oroshaza": {
    title: "Mobil szerviz Orosházán | NorbiPhone",
    description: "Mobiltelefon javítás Orosházán gyorsan és garanciával. Kijelzőcsere, akkucsere és teljes szerviz.",
    canonical: "/szerviz",
  },
  "/telefon-javitas-oroshaza": {
    title: "Telefon javítás Orosházán | NorbiPhone",
    description: "Telefon javítás Orosházán akár másnapra. iPhone, Samsung, Xiaomi, Honor, Huawei és más modellek.",
    canonical: "/szerviz",
  },
  // Hidrogél alias-ok
  "/hidrogel-folia-oroshaza": {
    title: "Hidrogél fólia Orosházán",
    description: "Önregeneráló hidrogél fólia felhelyezés Orosházán. iPhone, Samsung, Xiaomi és más márkákra.",
    canonical: "/hidrogel",
  },
  "/telefon-folia-oroshaza": {
    title: "Telefon fólia felhelyezés Orosházán | NorbiPhone",
    description: "Hidrogél kijelzővédő fólia felhelyezés Orosházán, tökéletes illeszkedéssel.",
    canonical: "/hidrogel",
  },
  // Telefonok alias-ok
  "/hasznalt-iphone-oroshaza": {
    title: "Használt iPhone Orosházán",
    description: "Átvizsgált használt iPhone készülékek garanciával és beszámítási lehetőséggel.",
    canonical: "/telefonok",
  },
  // ── Hibajelenség-alias-ok (szerviz) ────────────────────────────────────────
  "/iphone-nem-tolt-oroshaza": {
    title: "Nem tölt az iPhone? Javítás Orosházán",
    description: "Nem tölt vagy szakad a töltés? Töltőcsatlakozó tisztítás és csere Orosházán, ingyenes bevizsgálással és 6 hónap garanciával.",
    canonical: "/szerviz",
  },
  "/iphone-nem-kapcsol-be-oroshaza": {
    title: "Nem kapcsol be az iPhone? Szerviz Orosházán",
    description: "Nem indul el a telefonod? Megnézzük, mi okozza – akkumulátor, töltés vagy alaplap. Ingyenes bevizsgálás Orosházán, előre megmondott árral.",
    canonical: "/szerviz",
  },
  "/betort-kijelzo-javitas-oroshaza": {
    title: "Betört kijelző javítás Orosházán",
    description: "Betört vagy repedt a telefonod kijelzője? Kijelzőcsere Orosházán, gyári és OEM alkatrésszel, 6 hónap garanciával. Sok modell akár másnapra kész.",
    canonical: "/szerviz",
  },
  "/vizbe-esett-telefon-oroshaza": {
    title: "Vízbe esett telefon mentése Orosházán",
    description: "Beázott a telefonod? Hozd be minél előbb – megnézzük, mi menthető. Őszintén megmondjuk az esélyeket, a bevizsgálás ingyenes.",
    canonical: "/szerviz",
  },
  "/telefon-akkumulatora-gyorsan-lemerul-oroshaza": {
    title: "Gyorsan lemerül a telefon? Akkucsere Orosházán",
    description: "Fél nap alatt lemerül a telefonod? Megmérjük az akkumulátor állapotát, és megmondjuk, megéri-e cserélni. Csere 6 hónap garanciával.",
    canonical: "/szerviz",
  },
  "/iphone-kijelzo-csere-arak-oroshaza": {
    title: "iPhone kijelzőcsere árak Orosházán",
    description: "Modellenkénti iPhone kijelzőcsere árlista Orosházán: utángyártott és gyári Apple alkatrész. Az árak tájékoztatók, a bevizsgálás ingyenes.",
    canonical: "/szerviz",
  },
  "/samsung-kijelzo-csere-arak-oroshaza": {
    title: "Samsung kijelzőcsere árak Orosházán",
    description: "Samsung Galaxy kijelzőcsere árak Orosházán. Az alkatrészár modellenként változik, ezért egyedi ajánlatot adunk – a bevizsgálás ingyenes.",
    canonical: "/szerviz",
  },
  "/telefon-javitas-azonnal-oroshaza": {
    title: "Azonnali telefonjavítás Orosházán",
    description: "Sürgős a javítás? Raktáron lévő alkatrésszel sok hibát még aznap vagy másnapra megoldunk. Hívj minket, és megmondjuk, mikorra lesz kész.",
    canonical: "/szerviz",
  },
  // ── Fólia-alias-ok ─────────────────────────────────────────────────────────
  "/iphone-folia-oroshaza": {
    title: "iPhone fólia felhelyezés Orosházán",
    description: "Hidrogél kijelzővédő fólia iPhone-ra, buborékmentesen felhelyezve Orosházán. 14 nap garancia: ha felválik, ingyen újrarakjuk.",
    canonical: "/hidrogel",
  },
  "/samsung-folia-oroshaza": {
    title: "Samsung fólia felhelyezés Orosházán",
    description: "Hidrogél fólia Samsung Galaxy készülékekre, ívelt kijelzőre is. Helyben felhelyezzük Orosházán, 14 nap garanciával.",
    canonical: "/hidrogel",
  },
  "/privacy-folia-oroshaza": {
    title: "Privacy (betekintésgátló) fólia Orosházán",
    description: "Betekintésgátló hidrogél fólia: oldalról nem látszik a kijelződ. Felhelyezés helyben, Orosházán, 14 nap garanciával.",
    canonical: "/hidrogel",
  },
  "/onjavito-folia-oroshaza": {
    title: "Önregeneráló fólia Orosházán",
    description: "Az önregeneráló hidrogél fólia a kisebb karcokat magától eltünteti. Felhelyezés Orosházán, buborékmentesen, 14 nap garanciával.",
    canonical: "/hidrogel",
  },
  "/telefon-kijelzovedo-folia-oroshaza": {
    title: "Kijelzővédő fólia Orosházán",
    description: "Kijelzővédő fólia szinte minden telefontípusra, helyben felhelyezve Orosházán. Hidrogél és üvegfólia – megmondjuk, melyik mire jó.",
    canonical: "/hidrogel",
  },
  "/uvegfolia-helyett-oroshaza": {
    title: "Üvegfólia helyett hidrogél – Orosháza",
    description: "Miben más a hidrogél fólia, mint az üvegfólia? Elmondjuk őszintén, melyik való a te telefonodhoz – és fel is helyezzük Orosházán.",
    canonical: "/hidrogel",
  },
  // ── Felvásárlás-alias-ok ───────────────────────────────────────────────────
  "/telefon-felvasarlas-oroshaza": {
    title: "Telefon felvásárlás Orosházán",
    description: "Megvesszük a régi telefonodat készpénzért Orosházán. 15 perces bevizsgálás, tételes ár-levezetés, azonnali fizetés a pultnál.",
    canonical: "/felvasarlas",
  },
  "/hasznalt-telefon-eladas-oroshaza": {
    title: "Használt telefon eladása Orosházán",
    description: "El szeretnéd adni a telefonod? Megmondjuk, mennyit ér, és azonnal fizetünk készpénzben. Beszámítás esetén magasabb árat adunk.",
    canonical: "/felvasarlas",
  },
  "/hasznalt-telefon-felvasarlas-oroshaza": {
    title: "Használt telefon felvásárlás Orosházán",
    description: "Használt készülék felvásárlása Orosházán: iPhone, Samsung, Xiaomi. Tételes levezetés arról, mi mennyit von le az árból.",
    canonical: "/felvasarlas",
  },
  "/iphone-eladas-oroshaza": {
    title: "iPhone eladása Orosházán",
    description: "Eladnád az iPhone-od? 15 perc alatt bevizsgáljuk és megmondjuk az árat. Készpénz azonnal, vagy magasabb ár beszámítás esetén.",
    canonical: "/felvasarlas",
  },
  "/samsung-eladas-oroshaza": {
    title: "Samsung eladása Orosházán",
    description: "Samsung Galaxy készülék felvásárlása Orosházán. Megmondjuk, mennyit ér, és mi az, ami levon az árából – kötelezettség nélkül.",
    canonical: "/felvasarlas",
  },
  "/telefon-becsere-oroshaza": {
    title: "Telefon becserélése Orosházán",
    description: "Régi telefonodat beszámítjuk egy újabb készülékbe Orosházán. A beszámítási ár mindig magasabb, mint a készpénzes.",
    canonical: "/felvasarlas",
  },
  "/telefon-eladas-azonnal-oroshaza": {
    title: "Telefon eladása azonnal – Orosháza",
    description: "Ma szeretnél túladni a telefonodon? Gyere be nyitvatartási időben: 15 perc bevizsgálás, utána azonnal fizetünk készpénzben.",
    canonical: "/felvasarlas",
  },
  "/ipad-eladas-oroshaza": {
    title: "iPad eladása Orosházán",
    description: "Megvesszük a használt iPadedet Orosházán. Bevizsgálás után pontos árat mondunk, és azonnal fizetünk – kötelezettség nélkül.",
    canonical: "/felvasarlas",
  },
  "/apple-watch-eladas-oroshaza": {
    title: "Apple Watch eladása Orosházán",
    description: "Apple Watch felvásárlás Orosházán. Megnézzük az állapotát és az akkumulátorát, majd konkrét árat mondunk – készpénz azonnal.",
    canonical: "/felvasarlas",
  },
};

/**
 * SEOAliasRoute – SEO alias útvonalak kezelője
 *
 * Az alias URL-en az eredeti oldal tartalmát rendereli,
 * de egyedi title/description SEO metadatával és a kanonikus
 * URL-t az eredeti oldalra állítja be.
 *
 * A SEOHead CHILDREN UTÁN van renderelve, hogy
 * react-helmet-async-ban felülírja az oldal saját SEO-ját.
 */
export default function SEOAliasRoute({ children }) {
  const { pathname } = useLocation();
  const seo = SEO_CONFIG[pathname];

  // Ha nincs alias konfiguráció, csak rendereli a gyereket
  if (!seo) return children;

  return (
    <>
      {children}
      {/* Alias SEOHead az oldal SEOHead-je UTÁN renderelődik,
          ezért felülírja azt react-helmet-async-ban.
          `metaOnly`: a JSON-LD-t az oldal saját SEOHead-je adja ki – itt egy
          második blokk duplikált @id-ket eredményezne. */}
      <SEOHead
        title={seo.title}
        description={seo.description}
        url={`https://norbiphone.hu${pathname}`}
        canonical={`https://norbiphone.hu${seo.canonical}`}
        metaOnly
      />
    </>
  );
}
